module.exports = __webpack_public_path__ + "static/media/back.d6d721f0.png";